
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

var RegularApplyPage = Vue.extend({})
Vue.component('regularApply-page', RegularApplyPage)

export default {
name: 'RegularApplyPage',
components: {
XTable,XButton,XDialog,Group,XInput,CellBox,Radio,PopupHeader,Popup,XTextarea,Flexbox,FlexboxItem,
},
directives: {
TransferDom
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '',
info: {},
refRecordId: '',
refModule: '',
showToast: false,//弹窗-dialog

employeeId: '',
employeeName: '',

departmentId: '',
departmentName: '',
job: '',
employeeNo: '',
beforeTurnPositionLevel: '',

registerTime: '',
finalReport: '',
workSuggestion: '',
createFlowDate: '',

firstStageBeginDate: '',
firstStageEndDate: '',

secondStageBeginDate: '',
secondStageEndDate: '',

checkTreeShow: false,
treeData: [],//人员结构树
checkTreeSearchVal: '',//人员结构树搜索内容
checkTreeSearchResult: [],//人员结构树搜索结果
treeProps: {
children: 'children',
label: 'name'
},
checkDeptResult: {},//人员结构树-选择结果

selectModelFlag: false, //下拉选择弹框控制
selectModelTitle: '', //下拉选择弹框标题
selectModelData:[], //下拉选择弹框数据
selectModel: '',

createFlowDate: '',//转正申请日期

fileObj: {},//文件上传集合
fileShowList: [],//上传文件集合-预览
uploadedFileIdList: [],//已上传文件ID集合

turnoverTypeList: [],
turnoverTypeValue: '',
turnoverType: '',
turnoverTypeId: '',

}
},
mounted () {
this.$emit('sendTitleToParent','人员转正申请');
this.axios({
url: this.baseUrl+'/wechat/positiveTurnover/turnoverApply',
method: 'get'
}).then((response) => {
console.log(response.data);
this.info = response.data.obj;
this.refRecordId = response.data.refRecordId;
this.refModule = response.data.refModule;
}).catch((response) => {
this.$vux.loading.hide();
});
this.getTurnoverType();
},
methods: {
openDialog (v) {// 打开选择业务-dialog
this.showToast = true;
this.getDeptTree();
},
showMsg (msg) {
this.$vux.alert.show({
title: msg
})
setTimeout(() => {
this.$vux.alert.hide()
}, 2000)
},
getDeptTree () {//获取人员架构
this.axios({
url: this.baseUrl+'/wechat/staff/getOrgStaff',
method: 'get'
}).then((response) => {
this.treeData = response.data;
this.checkTreeShow = true;
}).catch((response) => {
this.$vux.loading.hide();
});
},
clearSearchResult () {//清空搜索栏
this.checkTreeSearchResult = [];
},
clearDeptResult () {//清除组织架构
this.employeeName = '';
this.checkDeptResult = {};
},
treeSearch () {//提交-组织架构搜索按钮
this.checkTreeSearchResult = [];
let checkTreeSearchVal = this.checkTreeSearchVal;
let treeData = this.treeData;
if(checkTreeSearchVal!=''){
this.getArray(treeData,checkTreeSearchVal);
}
},
getArray (data,name) {//组织架构搜索-递归
for (var i in data) {
if (data[i].name == name || data[i].name.indexOf(name) != -1) {
this.checkTreeSearchResult.push(data[i]);
}else {
this.getArray(data[i].children, name);
}
}
},
addToTree (item) {//将搜索结果添加到树
let CheckedNodes = this.$refs.tree.getCheckedNodes();
CheckedNodes.push(item);
this.$refs.tree.setCheckedNodes(CheckedNodes);
this.checkTreeSearchResult = [];
},
getCheckedNodes() {//选择-人员架构树

let checkedPersonArr = this.$refs.tree.getCheckedNodes();

this.checkDeptResult = checkedPersonArr[0];
this.employeeId = this.checkDeptResult.id;
this.employeeName = this.checkDeptResult.name;
this.checkTreeShow = false;
this.showToast = false;
console.log('组织架构树',this.checkDeptResult,this.employeeName);
this.getStaffDetail();
},
getStaffDetail () {
this.axios({
url: this.baseUrl+'/wechat/staff/getStaffDetail?staffId='+this.employeeId,
method: 'get'
}).then((response) => {
console.log('getStaffDetail',response.data.staff);
this.employeeNo = response.data.staff.numberCode;
this.job = response.data.staff.rankName;
this.departmentName = response.data.staff.departmentName;
this.departmentId = response.data.staff.departmentId;
this.registerTime = response.data.staff.entryDate;
this.beforeTurnPositionLevel = response.data.staff.positionLevelName;
}).catch((response) => {
this.$vux.loading.hide();
});
},
getLeaveType (value, label) {

this.accountUniId = value;

let isChange = value == this.selectModel ? false : true
if(this.selectModelTitle == '请选择职务'){
this.selectModel = this.jobValue = value;
this.jobLabel = label;
} else if(this.selectModelTitle == '请选择职级') {
this.selectModel = this.positionLevelValue = value;
this.positionLevelLabel = label;
} else if(this.selectModelTitle == '请选择变动情况'){
this.selectModel = this.turnoverValue = value;
this.turnoverLabel = label;
}
if(isChange){
this.selectModelFlag = false;
}
console.log(this.selectModel)
},
chooseDate () {//转正申请日期
let that = this;
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.createFlowDate,
onConfirm (val) {
that.createFlowDate = val;
}
})
},
chooseDate1 () {//入职日期
let that = this;
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.registerTime,
onConfirm (val) {
that.registerTime = val;
}
})
},
chooseStartDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.firstStageBeginDate,
onConfirm (val) {
that.firstStageBeginDate = val
}
})
},
chooseEndDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.firstStageEndDate,
onConfirm (val) {
that.firstStageEndDate = val
}
})
},
chooseStartDate1 () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.secondStageBeginDate,
onConfirm (val) {
that.secondStageBeginDate = val
}
})
},
chooseEndDate1 () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD',
value: this.secondStageEndDate,
onConfirm (val) {
that.secondStageEndDate = val
}
})
},
chooseFile () { // 选择附件
this.fileObj = document.getElementById('file').files;
this.$vux.loading.show({
text: '保存中'
})
this.submitFile();
},
deleteFile (index) { // 删除已选附件
this.fileShowList.splice(index, 1)

let deleteFileId = this.uploadedFileIdList[index]
let fileData = new FormData()
fileData.append('fileId', deleteFileId)
this.$vux.loading.show({
text: '删除中'
});
this.axios({
url: this.baseUrl + '/wechat/commonFile/deleteFile',
method: 'post',
data: fileData
}).then((response) => {
this.$vux.loading.hide();
this.uploadedFileIdList.splice(index, 1)
}).catch((response) => {
this.$vux.loading.hide()
})
},
async submitFile () { // 上传附件-图片
let fileObjL = this.fileObj.length;
for (let i = 0; i < fileObjL; i++) {
let fileData = new FormData()
fileData.append('file', this.fileObj[i])
fileData.append('taskId', this.info.id)
fileData.append('refRecordId', this.refRecordId)
fileData.append('refModule', this.refModule)
let res = await this.axios({
url: this.baseUrl + '/wechat/commonFile/uploadFile',
method: 'post',
data: fileData
})
this.uploadedFileIdList.push(res.data.fileId)

let that = this
let file = this.fileObj[i]
let reader = new FileReader()
reader.readAsDataURL(file)
reader.onload = function (e) {
that.fileShowList.push(this.result)
}
}

this.$vux.loading.hide()
},

async getTurnoverType () {

let res = await this.axios({
url: this.baseUrl+'/wechat/commonInterface/listBaseDatas/POSITIVE_TURNOVER_TYPE',
method: 'get'
});

let list = res.data.list;
this.turnoverTypeList.push({id:'',name:''});
for(let i=0;i<list.length;i++){
this.turnoverTypeList.push(list[i]);
}
},

openSelectModelFlage(type,data){
console.log('openSelectModelFlage',type,data);
this.selectModelData = [];
if(type == 'turnoverType'){
this.selectModelTitle = '请选择转正类型';
this.selectModel = this.sex;
data.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}
this.selectModelFlag = true;
},
getLeaveType (value, label) {

this.turnoverTypeId = value;

let isChange = value == this.selectModel ? false : true
if(this.selectModelTitle == '请选择转正类型'){
this.selectModel = this.turnoverTypeValue = value;
this.turnoverType = label;
}
if(isChange){
this.selectModelFlag = false;
}
console.log(this.selectModel)
},
saveForm () {//保存
if(this.employeeName == ''){
this.showMsg('请补充必填信息');
return false;
}
this.$vux.loading.show({
text: '加载中'
});

let formData = new FormData();
formData.append("id",this.info.id);

formData.append("employeeId",this.employeeId);
formData.append("employeeName",this.employeeName);
formData.append("departmentId",this.departmentId);
formData.append("departmentName",this.departmentName);
formData.append("job",this.job);

if(this.employeeNo){
formData.append("employeeNo",this.employeeNo);
}else{
formData.append("employeeNo",'');
}

formData.append("beforeTurnPositionLevel",this.beforeTurnPositionLevel);
formData.append("registerTime",this.registerTime);

formData.append("finalReport",this.finalReport);
formData.append("workSuggestion",this.workSuggestion);
formData.append("createFlowDate",this.createFlowDate);
if(this.turnoverType){
formData.append("turnoverType",this.turnoverTypeValue);
}
formData.append("firstStageBeginDate",this.firstStageBeginDate);

formData.append("firstStageEndDate",this.firstStageEndDate);
formData.append("secondStageBeginDate",this.secondStageBeginDate);
formData.append("secondStageEndDate",this.secondStageEndDate);

this.axios({
url: this.baseUrl+'/wechat/positiveTurnover/saveForm',
method: 'post',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
},
data: formData,
}).then((response) => {
console.log('人事变动saveForm',response.data,this.saveStatus);
if(response.data.status == 0){//保存失败
this.$vux.loading.hide();
this.showMsg(response.data.msg);
}else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
this.startFlow();
}else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
this.$emit('sendStatusToParent',{status:1});
this.$vux.loading.hide();
}
}).catch((response) => {
this.$vux.loading.hide();
});
},
startFlow () {//发起
let startData = new FormData();
startData.append("id",this.info.id);
startData.append("flowId",this.info.flowId);
this.axios({
url: this.baseUrl+'/wechat/loan/startFlow',
method: 'post',
data: startData
}).then((response) => {
console.log('startFlow',response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if(response.data.status == 1){

this.$emit('sendStatusToParent',{
status:0,
id:response.data.taskId,
stepId:response.data.stepId
});
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
});

},
},
}



// WEBPACK FOOTER //
// ./src/components/launch/hr/regularApply.vue